import React, { type CSSProperties, type ReactNode } from 'react';

import type { RouteScrollMode } from './resolveRouteScrollMode';

const shellStyle: CSSProperties = {
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  height: '100%',
  minHeight: 0,
  overflow: 'hidden',
  width: '100%',
};

/** Column flex so PageLayout can `flex: 1` fill a definite shell height (percentage height would be auto here). */
const scrollStyle: CSSProperties = {
  WebkitOverflowScrolling: 'touch',
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  minHeight: 0,
  overflowY: 'auto',
  width: '100%',
};

export type RouteShellProps = {
  children: ReactNode;
  mode: RouteScrollMode;
  className?: string;
  style?: CSSProperties;
};

/** App shell for authenticated routes (ADR 0001). Applied once in CheckRole. */
export const RouteShell: React.FC<RouteShellProps> = ({ children, mode, className, style }) => {
  if (mode === 'none') {
    return <>{children}</>;
  }

  return (
    <div className={className} style={{ ...shellStyle, ...style }}>
      <div data-route-scroll-region style={scrollStyle}>
        {children}
      </div>
    </div>
  );
};
